module.exports = "/shifts/components/salesImportTableComponent-c42148.html";